import { useTranslations } from 'next-intl';
import { MdCheckCircleOutline, MdOutlineDangerous } from 'react-icons/md';

export default function PasswordValidation({
  passwordValidation = '',
}: {
  passwordValidation: string;
}) {
  const t = useTranslations('RegistrationForm');
  const allClasses = 'p-2 py-1';
  const okClasses = 'bg-[green] ' + allClasses;
  const errorClasses = 'bg-brand-alt ' + allClasses;

  if (!passwordValidation) {
    passwordValidation = '';
  }
  return (
    <ul className='flex flex-wrap gap-2 text-xs'>
      <li
        className={`${
          passwordValidation.includes('length') ? errorClasses : okClasses
        }`}
      >
        {passwordValidation.includes('length') ? (
          <MdOutlineDangerous className='inline' />
        ) : (
          <MdCheckCircleOutline className='inline' />
        )}{' '}
        {t('validation.minCharacters')}
      </li>
      <li
        className={`${
          passwordValidation.includes('lower') ? errorClasses : okClasses
        }`}
      >
        {passwordValidation.includes('lower') ? (
          <MdOutlineDangerous className='inline' />
        ) : (
          <MdCheckCircleOutline className='inline' />
        )}{' '}
        {t('validation.lowercase')}
      </li>
      <li
        className={
          passwordValidation.includes('upper') ? errorClasses : okClasses
        }
      >
        {passwordValidation.includes('upper') ? (
          <MdOutlineDangerous className='inline' />
        ) : (
          <MdCheckCircleOutline className='inline' />
        )}{' '}
        {t('validation.uppercase')}
      </li>
      <li
        className={`${
          passwordValidation.includes('digit') ? errorClasses : okClasses
        }`}
      >
        {passwordValidation.includes('digit') ? (
          <MdOutlineDangerous className='inline' />
        ) : (
          <MdCheckCircleOutline className='inline' />
        )}{' '}
        {t('validation.digit')}
      </li>
      <li
        className={`${
          passwordValidation.includes('special') ? errorClasses : okClasses
        }`}
      >
        {passwordValidation.includes('special') ? (
          <MdOutlineDangerous className='inline' />
        ) : (
          <MdCheckCircleOutline className='inline' />
        )}{' '}
        {t('validation.special')}
      </li>
    </ul>
  );
}
